export const MAXPREPS_STAT_SUPPLIER_ID = process.env.REACT_APP_MAXPREPS_STAT_SUPPLIER_ID || '';

export const API_URLS = {
  // Base URL
  BASE_URL: process.env.REACT_APP_API_URL,

  // Auth
  LOGIN: `${process.env.REACT_APP_API_URL}/auth/user/login`,
  EMPLOYEE_LOGIN: `${process.env.REACT_APP_API_URL}/auth/employee/login`,
  GETROLES: `${process.env.REACT_APP_API_URL}/auth/user/roles`,
  GET_DEFAULT_PERMISSIONS: `${process.env.REACT_APP_API_URL}/auth/user/default-permissions`,
  PASSWORD_RESET_REQUEST: `${process.env.REACT_APP_API_URL}/auth/user/password-reset-request`,
  PASSWORD_RESET_CONFIRM: `${process.env.REACT_APP_API_URL}/auth/user/password-reset-confirm`,
  EMPLOYEE_PASSWORD_RESET_REQUEST: `${process.env.REACT_APP_API_URL}/auth/employee/password-reset-request`,
  EMPLOYEE_PASSWORD_RESET_CONFIRM: `${process.env.REACT_APP_API_URL}/auth/employee/password-reset-confirm`,

  // Clients
  ADD_CLIENT_WITH_INVITE: `${process.env.REACT_APP_API_URL}/setup/clients/add-with-invite`,
  GET_CLIENTS: `${process.env.REACT_APP_API_URL}/setup/clients`,
  GET_ALL_CLIENTS: `${process.env.REACT_APP_API_URL}/setup/clients/all`,
  GET_ALL_ACTIVE_CLIENTS: `${process.env.REACT_APP_API_URL}/setup/clients/active`,
  UPDATE_CLIENT: `${process.env.REACT_APP_API_URL}/setup/clients/update`,
  DELETE_CLIENT: `${process.env.REACT_APP_API_URL}/setup/clients/delete`,
  GET_CLIENT_BY_ID: `${process.env.REACT_APP_API_URL}/setup/clients/by-id`,

  // Seasons
  ADD_SEASON: `${process.env.REACT_APP_API_URL}/seasons/add`,
  GET_SEASONS: `${process.env.REACT_APP_API_URL}/seasons`,
  GET_SEASON_PERIOD: `${process.env.REACT_APP_API_URL}/seasons/period`,
  GET_ALL_SEASONS: `${process.env.REACT_APP_API_URL}/seasons/all`,
  GET_ACTIVE_SEASONS: `${process.env.REACT_APP_API_URL}/seasons/active`,
  GET_SEASON_BY_ID: `${process.env.REACT_APP_API_URL}/seasons`,
  UPDATE_SEASON: `${process.env.REACT_APP_API_URL}/seasons/update`,
  DELETE_SEASON: `${process.env.REACT_APP_API_URL}/seasons/delete`,
  GET_SEASON_GAMES: `${process.env.REACT_APP_API_URL}/seasons/games`,
  GET_SEASON_STATS: `${process.env.REACT_APP_API_URL}/seasons/stats`,
  GET_SEASON_STAT_SERIES: `${process.env.REACT_APP_API_URL}/seasons/stat-series`,
  GET_SEASON_CHART_SERIES: `${process.env.REACT_APP_API_URL}/seasons/chart-series`,
  GET_SEASON_GRAPHIC_STATS: `${process.env.REACT_APP_API_URL}/seasons/graphic_stats`,
  GET_SEASON_KPI_TARGETS: `${process.env.REACT_APP_API_URL}/seasons/kpi-targets`,
  UPDATE_SEASON_KPI_TARGETS: `${process.env.REACT_APP_API_URL}/seasons/kpi-targets/update`,
  UPDATE_SEASON_STARTING_GOALIE: `${process.env.REACT_APP_API_URL}/seasons/starting-goalie`,

  // Users
  INVITE_USER: `${process.env.REACT_APP_API_URL}/setup/users/invite`,
  GET_USERS: `${process.env.REACT_APP_API_URL}/setup/users`,
  GET_ALL_USERS: `${process.env.REACT_APP_API_URL}/setup/users/all`,
  GET_CURRENT_USER: `${process.env.REACT_APP_API_URL}/setup/users/me`,
  GET_USER_ROLES: `${process.env.REACT_APP_API_URL}/setup/users/roles`,
  UPDATE_USER: `${process.env.REACT_APP_API_URL}/setup/users/update`,
  RESET_USER_PASSWORD: `${process.env.REACT_APP_API_URL}/setup/users/reset-password`,
  CHANGE_USER_PASSWORD: `${process.env.REACT_APP_API_URL}/setup/users/change-password`,
  CHANGE_EMPLOYEE_PASSWORD: `${process.env.REACT_APP_API_URL}/auth/employee/change-password`,
  DELETE_USER: `${process.env.REACT_APP_API_URL}/setup/users/delete`,

  // Stat Takers
  ADD_STAT_TAKERS: `${process.env.REACT_APP_API_URL}/setup/stat-takers/add`,

  // Admin Dashboard
  ADMIN_CLIENTS: `${process.env.REACT_APP_API_URL}/admin/clients`,
  ADMIN_CLIENT_SEASONS: `${process.env.REACT_APP_API_URL}/admin/clients`,
  ADMIN_LEADERBOARDS: `${process.env.REACT_APP_API_URL}/admin/leaderboards`,
  ADMIN_TOURNAMENTS: `${process.env.REACT_APP_API_URL}/admin/tournaments`,
  ADMIN_TOURNAMENT_LEADERBOARDS: `${process.env.REACT_APP_API_URL}/admin/tournament-leaderboards`,
  CLIENT_TOURNAMENTS: `${process.env.REACT_APP_API_URL}/games/tournaments`,

  // Players
  ADD_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/add`,
  GET_PLAYERS: `${process.env.REACT_APP_API_URL}/setup/players`,
  GET_ALL_PLAYERS: `${process.env.REACT_APP_API_URL}/setup/players/all`,
  GET_ACTIVE_PLAYERS_BY_CLIENT: `${process.env.REACT_APP_API_URL}/setup/players/all/active/by-client`,
  GET_PLAY_PLAYERS_BY_CLIENT: `${process.env.REACT_APP_API_URL}/setup/players/all/play/by-client`,
  UPDATE_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/update`,
  DELETE_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/delete`,
  GET_SEASON_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/get-season`,
  UPDATE_SEASON_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/update-season`,
  GET_RELATIVE_SEASON_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/get-relative-season`,
  GET_GAME_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/get-game`,
  GET_RELATIVE_GAME_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/get-relative-game`,
  UPDATE_GAME_PLAYER: `${process.env.REACT_APP_API_URL}/setup/players/update-game`,

  // Opponents
  ADD_OPPONENT: `${process.env.REACT_APP_API_URL}/setup/opponents/add`,
  GET_OPPONENTS: `${process.env.REACT_APP_API_URL}/setup/opponents`,
  GET_ALL_OPPONENTS: `${process.env.REACT_APP_API_URL}/setup/opponents/all`,
  UPDATE_OPPONENT: `${process.env.REACT_APP_API_URL}/setup/opponents/update`,
  DELETE_OPPONENT: `${process.env.REACT_APP_API_URL}/setup/opponents/delete`,

  // Games
  ADD_GAME: `${process.env.REACT_APP_API_URL}/games/add`,
  GET_GAMES: `${process.env.REACT_APP_API_URL}/games`,
  GET_GAME_BY_ID: `${process.env.REACT_APP_API_URL}/games`,
  UPDATE_GAME_PERIODS: `${process.env.REACT_APP_API_URL}/games`,
  GET_GAME_PERIODS: `${process.env.REACT_APP_API_URL}/games`,
  GET_GAME_PERIOD_SUGGESTED_TIMES: `${process.env.REACT_APP_API_URL}/games`,
  GET_GAMES_ALL: `${process.env.REACT_APP_API_URL}/games/all`,
  UPDATE_GAME_OT: `${process.env.REACT_APP_API_URL}/games/ot`,
  UPDATE_GAME: `${process.env.REACT_APP_API_URL}/games/update`,
  DELETE_GAME: `${process.env.REACT_APP_API_URL}/games/delete`,
  GET_GAME_DATA: `${process.env.REACT_APP_API_URL}/games`,
  UPDATE_GAME_QUARTER_TRACKING: `${process.env.REACT_APP_API_URL}/games/quarter/tracking`,
  GET_USER_TRACKING_ROLES: `${process.env.REACT_APP_API_URL}/games/user-tracking-roles`,
  UPDATE_USER_TRACKING_ROLES: `${process.env.REACT_APP_API_URL}/games/user-tracking-roles`,
  GET_GAME_KPI_TARGETS: `${process.env.REACT_APP_API_URL}/games/kpi-targets`,
  UPDATE_GAME_KPI_TARGETS: `${process.env.REACT_APP_API_URL}/games/kpi-targets/update`,
  UPDATE_GAME_GOALIE: `${process.env.REACT_APP_API_URL}/games`,

  // Bulk Import Feature
  UPLOAD_ROSTER: `${process.env.REACT_APP_API_URL}/upload/roster`,
  UPLOAD_SCHEDULE: `${process.env.REACT_APP_API_URL}/upload/schedule`,
  DOWNLOAD_ROSTER_TEMPLATE: `${process.env.REACT_APP_API_URL}/upload/templates/roster`,
  DOWNLOAD_SCHEDULE_TEMPLATE: `${process.env.REACT_APP_API_URL}/upload/templates/schedule`,

  // STATS
  ADD_STATS: `${process.env.REACT_APP_API_URL}/statslog/add`,
  ADD_STATS_BATCH: `${process.env.REACT_APP_API_URL}/statslog/add-batch`,
  SUBMIT_STATS: `${process.env.REACT_APP_API_URL}/statslog/submit`,
  ADD_PENALTY: `${process.env.REACT_APP_API_URL}/stats/penalty/add`,
  ADD_PENALTY_SUCCESS: `${process.env.REACT_APP_API_URL}/stats/penalty/add-success`,
  ADD_SHOT: `${process.env.REACT_APP_API_URL}/stats/shot/add`,
  ADD_POSSESSION_TIME: `${process.env.REACT_APP_API_URL}/stats/possessiontime/add`,
  POSSESSION_TIME_GET: `${process.env.REACT_APP_API_URL}/stats/possessiontime/get`,
  ADD_POSSESSION: `${process.env.REACT_APP_API_URL}/stats/possession/add`,
  ADD_CLEAR: `${process.env.REACT_APP_API_URL}/stats/clear/add`,
  ADD_FACE_OFF: `${process.env.REACT_APP_API_URL}/stats/faceoff/add`,
  GET_ALL_STATS: `${process.env.REACT_APP_API_URL}/statslog/all`,
  UPDATE_STATS: `${process.env.REACT_APP_API_URL}/statslog/update`,
  DELETE_STATS: `${process.env.REACT_APP_API_URL}/statslog/delete`,
  GET_PLAYER_STATS: `${process.env.REACT_APP_API_URL}/stats/players`,
  GET_PLAYER_STAT_SHEET: `${process.env.REACT_APP_API_URL}/stats/player-sheet`,
  GET_MOST_RECENT_QUARTER: `${process.env.REACT_APP_API_URL}/statslog/most-recent-quarter`,

  // Export
  EXPORT_DOWNLOAD: `${process.env.REACT_APP_API_URL}/export/download-leaderboard`,
  EXPORT_EMAIL: `${process.env.REACT_APP_API_URL}/export/email-leaderboard`,
  EXPORT_DOWNLOAD_COMPREHENSIVE: `${process.env.REACT_APP_API_URL}/export/download-comprehensive`,
  EXPORT_DOWNLOAD_PLAYER_SHEET: `${process.env.REACT_APP_API_URL}/export/download-player-sheet`,
  EXPORT_EMAIL_COMPREHENSIVE: `${process.env.REACT_APP_API_URL}/export/email-multi-report`,

  // Contact
  CONTACT_SUBMIT: `${process.env.REACT_APP_API_URL}/contact/submit`,
};

export const INVITE_URLS = {
  VALIDATE: `${process.env.REACT_APP_API_URL}/invites/validate`,
  ACCEPT: `${process.env.REACT_APP_API_URL}/invites/accept`,
};

export const SIGNUP_URLS = {
  SIGNUP: `${process.env.REACT_APP_API_URL}/signup`,
  ROLES: `${process.env.REACT_APP_API_URL}/signup/roles`,
  CONFIG: `${process.env.REACT_APP_API_URL}/signup/config`,
};

export const BILLING_URLS = {
  STATUS: `${process.env.REACT_APP_API_URL}/billing/status`,
  SUBSCRIPTION: `${process.env.REACT_APP_API_URL}/billing/subscription`,
  CREATE_CHECKOUT_SESSION: `${process.env.REACT_APP_API_URL}/billing/create-checkout-session`,
  AUTO_RENEWAL: `${process.env.REACT_APP_API_URL}/billing/auto-renewal`,
  CANCEL: `${process.env.REACT_APP_API_URL}/billing/cancel`,
};

// Billing status constants (must match backend)
export const BILLING_STATUS = {
  TRIAL: 'trial',
  INVOICE_DRAFT: 'invoice_draft', // Invoice created but not yet sent
  PENDING: 'pending', // Invoice sent, awaiting first payment
  ACTIVE: 'active', // Paid and active subscription
  INVOICE_SENT: 'invoice_sent', // Renewal date passed, within net-30 (full access)
  PAST_DUE: 'past_due', // Past invoice due date, within 14-day grace period
  SUSPENDED: 'suspended', // 14-day grace period expired, no login allowed
  CANCELED: 'canceled',
} as const;

export type BillingStatusType = (typeof BILLING_STATUS)[keyof typeof BILLING_STATUS];

export const TIMEZONES = [
  { value: 'alaska', label: 'US/Alaska' },
  { value: 'central', label: 'US/Central' },
  { value: 'eastern', label: 'US/Eastern' },
  { value: 'hawaii', label: 'US/Hawaii' },
  { value: 'mountain', label: 'US/Mountain' },
  { value: 'pacific', label: 'US/Pacific' },
];

export const POSITION_OPTIONS = ['Attack', 'Midfield', 'Defense', 'Goalie'];

export type EightMeterFoul = 'Shooting Space' | '3 Second' | 'Dangerous Check' | "Don't Know";

export const EIGHT_METER_FOUL_UNKNOWN: EightMeterFoul = "Don't Know";

export const EIGHT_METER_FOULS: { value: EightMeterFoul; label: string }[] = [
  { value: 'Shooting Space', label: 'Shooting Space' },
  { value: '3 Second', label: '3 Seconds' },
  { value: 'Dangerous Check', label: 'Dangerous Check' },
  { value: EIGHT_METER_FOUL_UNKNOWN, label: "Don't Know" },
];

export const STATSTYPE = [
  'Penalty Start',
  '8M Free Possession',
  'Penalty End',
  'Possession',
  'Shot Goal',
  'Assist',
  'Shot Saved',
  'Shot Missed',
  'Shot Blocked',
  'Shot not saved',
  'Shot Was Saved By',
  'Was Blocked By',
  'Ground Ball',
  'Caused Turnover',
  'Forced Turnover',
  'Turnover',
  'Shot Clock Violation',
  'Clear Success',
  'Clear Fail',
  'Faceoff Won',
  'Faceoff Lost',
  'Draw Control Earned',
];

// Employee Roles (mapping to database labels)
export const EMPLOYEE_ROLES = [
  { id: 'owner', label: 'Owner' },
  { id: 'customer_support', label: 'Customer Support' },
  { id: 'sales_marketing', label: 'Sales and Marketing' },
  { id: 'software_engineer', label: 'Software Engineer' },
];

// Filter options for Users page
export const USER_FILTER_OPTIONS = [
  { value: 'all', label: 'All Users' },
  { value: 'employees', label: 'Employees' },
];

// User Types
export const USER_TYPES = [
  { value: 'client', label: 'Client User' },
  { value: 'employee', label: 'Employee' },
];
